/* eslint-disable linebreak-style */
import { Button } from '@mui/material';
import i18n from '../common/i18n';
import '../../assests/css/headerStyle.css';
import MenuItems from './MenuItems';

import { AUTOGESTION, COMMERCE } from '../../api/env';
import safeGetEnv from '../../prerender';

const NavBar = () => {
  // Links derived from env vars
  const COMMERCE_LINK = safeGetEnv(COMMERCE);
  const CLIENT_LINK = safeGetEnv(AUTOGESTION);

  // "Dónde comprar" queda fuera del menú: su único submenú era comercios físicos, dado de baja.

  // i18n menu values are already objects {title, route} — use them directly
  const menuItems = [
    i18n.headerMenuHome,
    i18n.headerMenuBlog,
    i18n.headerMenuHelp,
  ];

  return (
    <>
      <ul className="menus menusCenter">
        {menuItems.map((item) => (
          <MenuItems items={item} key={item.title} />
        ))}
      </ul>
      <ul className="menus menusActions">
        <li>
          <a href={COMMERCE_LINK} target="_blank" rel="noopener noreferrer nofollow" style={{ textDecoration: 'none' }}>
            <Button sx={{ marginLeft: '10px' }} variant="outlined" className="headerActionBtn headerActionBtnSecondary">
              {i18n.headerCommerce}
            </Button>
          </a>
          <a href={CLIENT_LINK} target="_blank" rel="noopener noreferrer nofollow" style={{ textDecoration: 'none' }}>
            <Button sx={{ marginLeft: '10px' }} variant="contained" className="headerActionBtn headerActionBtnPrimary">
              {i18n.headerClient}
            </Button>
          </a>
        </li>
      </ul>
    </>
  );
};

export default NavBar;
